const config = {
  systemName: process.env.REACT_APP_SNA || "Sistema ImpactoSociedade.com.br (dev)",
  apiUrl: process.env.REACT_APP_API || "http://localhost:3001",
};

export default config;
